export default {
      id: "areas-2-usage",
      viewBox: "0 0 25 25",
      url: "/" + "assets/sprite.svg#areas-2",
      toString: function () {
        return this.url;
      }
    }